import {SessionsRoute} from "./routes/Sessions.js";
const routes = [SessionsRoute];
export default routes;
